



















import Vue from 'vue';

export default Vue.extend({
  name: 'Example',

  data: () => ({
    events: [
      {
        name: 'Hello',
        location: 'Szeged',
      },
      {
        name: 'Other Event',
        location: 'Budapest',
      },
    ],
  }),
});
